export const NAME = 'FlightTrackerSearch';
